<template>
  <li class="octadesk-chat-message-item">
    <span class="octadesk-app-join-room">
      <span>
        {{
          $t('conversation.closed', {
            name: chat.closed.user.displayName || chat.closed.user.name
          })
        }}
      </span>
    </span>
  </li>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['chat'])
    }
  }
</script>

<style></style>
